export interface NamedEntityDto {
	id: number;
	name?: string;
}

export interface NamedDto {
	id: any;
	name?: string;
}

export interface TeacherDto extends NamedEntityDto {
	subjects: NamedEntityDto[];
	subjectGroupCount?: number;
	subjectGroupCounts?: TeacherSubjectGroupCountDto[];
}

export interface TeacherSubjectGroupCountDto {
	subjectId: number;
	count: number;
}

export interface EnumItemDto {
	id: number;
	key: string;
	name: string;
	shortName?: string;
	order?: number;
}

export interface RefItemDto {
	id: number;
	name: string;
	shortName: string;
	predefined: boolean | null;
	extraInfo: NamedEntityDto;
	isUsed: boolean | null;
	order: number | null;
}

export interface GlobalyearDto extends NamedEntityDto {
	startDate: Date;
	endDate: Date;
}

export interface SchoolyearDto extends NamedEntityDto {
	closed: string;
	schoolId: number;
	startDate: Date;
	endDate: Date;
	globalYear: GlobalyearDto;
}

export interface UploadLimits {
	fileSizeLimit: number;
	maximumUploadRequestSizeLimit: number;
	photoFileSizeLimit: number;
	portfolioDocFileSizeLimit: number;
	portfolioDocFileFileExts: string;
	schoolDocFileSizeLimit: number;
	schoolDocFileExts: string;
	laImportFileSizeLimit: number;
	plannerDocFileNoteSizeLimit: number;
	diaryFileResultSizeLimit: number;
	diaryFileResultFileExts: string;
	resizeAnswerImageWidth: number;
	resizeAnswerImageQuality: number;
	resizeAnswerImageMaxFileSize: number;
	mailFileSizeLimit: number;
	mailFileExts: string;
	resizeMailImageWidth: number;
	resizeMailImageMaxFileSize: number;
	assignmentFileSizeLimit: number;
	assignmentFileExts: string;
	resizeAssignmentImageWidth: number;
	resizeAssignmentImageMaxFileSize: number;
}

export interface ISelectable {
	selected?: boolean;
}

export interface CalendarEvent {
	startDate: Date;
	endDate: Date;
}

export interface MoveDayDto {
	dateFrom: Date;
	dateTo: Date;
	description: string;
}

export interface CalendarInfo {
	vacations: CalendarEvent[];
	holidays: CalendarEvent[];
	moveDays?: MoveDayDto[];
}

export enum FuncType {
	educMgr = 0,
	preSchool = 1,
	school = 2,
	addSchool = 3,
	profSchool = 4,
	orphanage = 5,
	university = 6,
}

export enum StatusOrganization {
	functions = 1,
	overhaul = 2,
	reconstruction = 3,
	suspendedActivities = 4,
	noContingent = 5,
	expectsOpening = 6,
	liquidated = 7,
	closed = 8,
	attachedToAnotherOrganization = 9
}

export interface SearchUserDto extends NamedEntityDto {
	birthDate?: Date;
	className?: string;
}

export enum Gender {
	Male = "Male",
	Female = "Female"
}

export enum RoleGroup {
	Staffs = "Staffs",
	Students = "Students",
	Parents = "Parents",
	EducManagers = "EducManagers"
}

export interface FileAttachInfoDto {
	attachmentGuid: string;
	description?: string;
	name: string;
	originalFileName?: string;
}

export interface FileDescriptionDto {
	fileDescription: string;
	attachmentType: number | null;
}

export interface DateRange {
	start: Date;
	end: Date;
}

export enum AppConstants {
	adminName = "ADMIN"
}

export interface TreeItem {
	id: number;
	title: string;
	isFolder?: boolean;
	level: number;
	expand: boolean;
	own: any;
	key: number;
	children?: TreeItem[];
	select: boolean;
	readOnly: boolean;
	attach: any;
	subjectId: number;
	nodeType: string;
	activate: boolean;
	focus: boolean;

}

declare global {
	interface String {
		escapeHTML(): string;
	}
}
